<script setup>
import { onMounted, ref } from "vue";
import { invocer, savedRequest,updateRequest } from '../api/invoicer';
import { municipality, contries, technical } from '../api/technicalAnnex';

import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import Dialog from 'primevue/dialog';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Toast from 'primevue/toast';
import Select from 'primevue/select';
import { FilterMatchMode } from '@primevue/core/api';
import { useToast } from "primevue/usetoast";


const activeSpinner = ref(false)
const columns = [
  { field: 'id_facturador', header: 'Id' },
  { field: 'razon_social', header: 'Razon Social' },
  { field: 'codigo_doc', header: 'Cod.Doc.' },
  { field: 'documento', header: 'Nit' },
  { field: 'direccion', header: 'Dirección' },
  { field: 'telefono', header: 'Telefono' },
  { field: 'correo', header: 'Correo' }
];

const toast = useToast();
const dataSource = ref([]);
const valuesRut = ref([null]);
const valuesUbication = ref([null]);
const visible = ref(false);
const modalCreated = ref(false);
const modalUpdate = ref(false);
const title = ref('');

//ObjetsArray Municipios && Departamentos
const munDep = ref([]);
const municipalities = ref([]);
const departments = ref([]);

//ObjetsArray Paises
const contry = ref([]);

//ObjetsArray Technical
const arrTechnical = ref([]);

//Source of Saved Data
const id = ref(0)
const id_invoicer = ref('');
const dv = ref(0);
const doc_code = ref(0);
const document = ref(0);
const taxpayer_code = ref(0);
const activity_code = ref(0);
const register_name = ref('');
const trade_name = ref('');
const email = ref('');
const phone = ref(0);
const address = ref('');
const agent_name = ref('');
const agent_email = ref('');
const agent_phone = ref(0);
const zip_code = ref('');
const software_id = ref('');
const pin = ref(0);
const supplier_authorization = ref(0);
const operation_type = ref(0);
const profile_operation = ref('');
const level_duties = ref('');
const scheme_duties = ref('')
const selectedCountry = ref(null);
const selectedCodeCountry = ref(null);
const selectedDeparment = ref(null);
const selectedCodeDeparment = ref(null);
const selectedMunicipaly = ref(null);
const selectedCodeMunicipaly = ref(null);


const clearData = () => {
  id.value= 0
  id_invoicer.value= '';
  dv.value= 0;
  doc_code.value= 0;
  document.value= 0;
  taxpayer_code.value= 0;
  activity_code.value= 0;
  register_name.value= '';
  trade_name.value= '';
  email.value= '';
  phone.value= 0;
  address.value= '';
  agent_name.value= '';
  agent_email.value= '';
  agent_phone.value= 0;
  zip_code.value= '';
  software_id.value= '';
  pin.value= 0;
  supplier_authorization.value= 0;
  operation_type.value= 0;
  profile_operation.value= '';
  level_duties.value= '';
  scheme_duties.value= ''
  selectedCountry.value = null
  selectedCodeCountry.value = null
  selectedDeparment.value = null
  selectedCodeDeparment.value = null
  selectedMunicipaly.value = null
  selectedCodeMunicipaly.value = null
}

const selectedCodeDept = () => {
  let code = selectedDeparment.value.codigo != undefined ? selectedDeparment.value.codigo : selectedDeparment.value;
  selectedCodeDeparment.value = code
}

const selectedCodeMun = () => {
  let code = selectedMunicipaly.value.codigo != undefined ? selectedMunicipaly.value.codigo : selectedMunicipaly.value;
  selectedCodeMunicipaly.value = code;
}

const selectContryCode = () => {
  let code = selectedCountry.value.codigo_numerico != undefined ? selectedCountry.value.codigo_numerico : selectedCountry.value;
  selectedCodeCountry.value = code
}

const loadBusiness = async () => {
  activeSpinner.value = true;
  try {
    let result = await invocer()
    dataSource.value = result.data.data;
    activeSpinner.value = false;
  } catch (error) {
    console.log(error);
  }
}

const showMoreInfo = (data) => {
  visible.value = true;
  title.value = data.nombre;
  valuesRut.value = [
    { name: "DV", value: data.dv },
    { name: "Cod. Contribuyente", value: data.codigo_contribuyente },
    { name: "Cod. Actividad", value: data.codigo_actividad },
    { name: "Cod. Responsabilidad Fiscal", value: data.cod_responsabilidad_fiscal },
    { name: "Software ID", value: data.software_id },
    { name: "Pin", value: data.pin },
    { name: "Autorizacion Proveedor", value: data.proveedor_autorizacion },
    { name: "Tipo De Operacion", value: data.tipo_operacion },
    { name: "Perfil De Operacion", value: data.perfil_operacion },
    { name: "Nivel De Impuestos", value: data.nivel_impuesto },
    { name: "Esquema De Impuestos", value: data.esquema_impuesto },
  ]

  valuesUbication.value = [
    { name: "Representante", value: data.nombre_representante },
    { name: "Correo", value: data.correo_representante },
    { name: "Telefono", value: data.tel_representante },
    { name: "Nombre Comercial", value: data.nombre_comercial },
    { name: "Cod. Postal", value: data.codigo_postal },
    { name: "Municipio", value: data.ciudad_municipio },
    { name: "Cod. Municipio", value: data.codigo_municipio },
    { name: "Departamento", value: data.departamento },
    { name: "Cod. Departamento", value: data.codigo_departamento },
    { name: "Pais", value: data.pais },
    { name: "Cod. Pais", value: data.codigo_pais }
  ]
}

const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});

const department = () => {
  departments.value = munDep.value.reduce((acc, curr) => {
    const existing = acc.find(item => item.departamento === curr.nombre_departamento);
    return existing ? acc : [...acc, { codigo: curr.codigo_departamento, departamento: curr.nombre_departamento }];
  }, []);
}

const municipalityAndCode = () => {
  selectedCodeDept();
  selectedCodeMunicipaly.value = null;
  municipalities.value = [];
  const code = selectedCodeDeparment.value
  municipalities.value = munDep.value
    .filter(item => item.codigo_departamento === code)
    .map(item => ({
      codigo: item.codigo_municipio,
      municipio: item.nombre_municipio
    }));
}

const loadNecesaryDataForm = async () => {
  let municipalitiesAndDepartments = await municipality();
  let datacontries = await contries();
  let datatechnical = await technical();
  munDep.value = municipalitiesAndDepartments.data.data;
  contry.value = datacontries.data.data;
  arrTechnical.value = datatechnical.data.data.documento_identificador;
}

const showModalCreate = async () => {
  clearData();
  modalCreated.value = true;
  await loadNecesaryDataForm();
  department();
}

const editProduct = async (data) => {
  await loadNecesaryDataForm();
  department();
  modalUpdate.value = true;

  //loadForm
  id.value = data.id
  id_invoicer.value = data.id_facturador ; 
  dv.value = data.dv ; 
  doc_code.value = data.codigo_doc ; 
  document.value = data.documento ; 
  taxpayer_code.value = data.codigo_contribuyente ; 
  activity_code.value = data.codigo_actividad ; 
  register_name.value = data.razon_social ; 
  trade_name.value = data.nombre_comercial ; 
  email.value = data.correo ; 
  phone.value = data.telefono ; 
  address.value = data.direccion ; 
  agent_name.value = data.nombre_representante ; 
  agent_email.value = data.correo_representante ; 
  agent_phone.value = data.tel_representante ; 
  zip_code.value = data.codigo_postal ; 
  software_id.value = data.software_id ; 
  pin.value = data.pin ; 
  supplier_authorization.value = data.proveedor_autorizacion;
  operation_type.value = data.tipo_operacion ; 
  profile_operation.value = data.perfil_operacion ; 
  level_duties.value = data.nivel_impuesto ; 
  scheme_duties.value = data.esquema_impuesto ; 
  selectedCountry.value = parseInt(data.codigo_pais)
  selectedCodeCountry.value = data.codigo_pais
  selectedDeparment.value = data.codigo_departamento.startsWith('0') ? data.codigo_departamento : parseInt(data.codigo_departamento)
  selectedCodeDeparment.value = data.codigo_departamento
  municipalityAndCode();
  selectedMunicipaly.value = data.codigo_municipio.startsWith('0') ? data.codigo_municipio : parseInt(data.codigo_municipio);
  selectedCodeMunicipaly.value = data.codigo_municipio
}

const save = async () => {
  let data = {
    id_facturador: id_invoicer.value,
    dv: dv.value,
    codigo_doc: doc_code.value,
    documento: document.value,
    codigo_contribuyente: taxpayer_code.value,
    codigo_actividad: activity_code.value,
    razon_social: register_name.value,
    nombre_comercial: trade_name.value,
    correo: email.value,
    telefono: phone.value,
    direccion: address.value,
    nombre_representante: agent_name.value,
    correo_representante: agent_email.value,
    tel_representante: agent_phone.value,
    codigo_postal: zip_code.value,
    codigo_municipio: selectedCodeMunicipaly.value,
    ciudad_municipio: selectedMunicipaly.value.municipio,
    codigo_departamento: selectedCodeDeparment.value,
    departamento: selectedDeparment.value.departamento,
    codigo_pais: selectedCodeCountry.value,
    pais: selectedCountry.value.nombre_comun,
    software_id: software_id.value,
    pin: pin.value,
    proveedor_autorizacion: supplier_authorization.value,
    tipo_operacion: operation_type.value,
    perfil_operacion: profile_operation.value,
    nivel_impuesto: level_duties.value,
    esquema_impuesto: scheme_duties.value
  }

  let res = await savedRequest(data);
  if (res.status == 201 && res.data.message == 'saved successfully invoicer') {
    modalCreated.value = false;
    toast.add({ severity: 'success', summary: 'Facturador', detail: 'Creado Correctamente', life: 4000 });
    loadBusiness();
    clearData();
  }
}

const update = async() => {
  const codeMunicipaly = selectedMunicipaly.value;
  const codeCountry = selectedCodeCountry.value;
  let [{nombre_municipio,nombre_departamento}] = munDep.value.filter(item => item.codigo_municipio == codeMunicipaly)
  let [{nombre_comun}] = contry.value.filter(item => item.codigo_numerico == codeCountry)
  let data = {
    id: id.value,
    id_facturador: id_invoicer.value,
    dv: dv.value,
    codigo_doc: doc_code.value,
    documento: document.value,
    codigo_contribuyente: taxpayer_code.value,
    codigo_actividad: activity_code.value,
    razon_social: register_name.value,
    nombre_comercial: trade_name.value,
    correo: email.value,
    telefono: phone.value,
    direccion: address.value,
    nombre_representante: agent_name.value,
    correo_representante: agent_email.value,
    tel_representante: agent_phone.value,
    codigo_postal: zip_code.value,
    software_id: software_id.value,
    pin: pin.value,
    proveedor_autorizacion: supplier_authorization.value,
    tipo_operacion: operation_type.value,
    perfil_operacion: profile_operation.value,
    nivel_impuesto: level_duties.value,
    esquema_impuesto: scheme_duties.value,
    codigo_municipio: selectedCodeMunicipaly.value,
    ciudad_municipio: nombre_municipio,
    codigo_departamento: selectedCodeDeparment.value,
    departamento: nombre_departamento,
    codigo_pais: selectedCodeCountry.value,
    pais: nombre_comun
  }
  let res = await updateRequest(data);
  if(res.status == 201 && res.data.message == 'update successfully invoicer'){
    modalUpdate.value = false;
    toast.add({ severity: 'info', summary: 'Facturador', detail: 'Actualizado Correctamente', life: 4000 });
    loadBusiness();
    clearData();
  }
}

onMounted(() => {
  loadBusiness();
});
</script>

<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>Configuracion Facturador</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2 mt-4">
      <Toolbar class="mb-6 m-3">
        <template #start>
          <Button label="Crear" icon="pi pi-plus" severity="success" class="m-2" @click="showModalCreate" />
          <Button label="Recargar" icon="pi pi-replay" severity="info" class="m-2" @click="loadBusiness" />
          <Toast />
        </template>
        <template #end>
          <IconField>
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
          </IconField>
        </template>
      </Toolbar>

      <div v-if="activeSpinner" class="flex justify-content-center align-items-center text-center mb-5">
        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
      </div>

      <DataTable v-if="!activeSpinner" class="m-3 text-center" :value="dataSource" :paginator="true" :rows="5"
        :rowsPerPageOptions="[5, 10, 20, 50]" :filters="filters" stripedRows resizableColumns columnResizeMode="fit"
        showGridlines tableStyle="min-width: 50rem">
        <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column>
        <Column :exportable="false" style="min-width: 1rem">
          <template #body="slotProps">
            <Button icon="pi pi-pencil" outlined rounded class="mr-2" severity="info"
              @click="editProduct(slotProps.data)" />
            <Button icon="pi pi-eye" outlined rounded class="mr-2" severity="success"
              @click="showMoreInfo(slotProps.data)" />
          </template>
        </Column>
      </DataTable>

      <!-- //---Modal View More---// -->
      <Dialog v-model:visible="visible" position="topright" modal :header="title" :style="{ width: '100%' }">
        <Splitter style="height: 560px" class="mb-4">
          <SplitterPanel class="flex items-center justify-center text-center">
            <h5 class="text-center mt-2">RUT</h5>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, id) in valuesRut" :key="id">
                  <th>{{ item.name }}</th>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
          </SplitterPanel>
          <SplitterPanel class="flex items-center justify-center">
            <h5 class="text-center mt-2">Ubicacion</h5>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, id) in valuesUbication" :key="id">
                  <th>{{ item.name }}</th>
                  <td>{{ item.value }}</td>
                </tr>
              </tbody>
            </table>
          </SplitterPanel>
        </Splitter>
      </Dialog>

      <!-- //---Modal Create---// -->
      <Dialog v-model:visible="modalCreated" position="top" modal :header="title" :style="{ width: '100%' }">
        <template #header>
          <div class="inline-flex items-center justify-center gap-2">
            <span class="font-bold whitespace-nowrap">Guardar Facturador</span>
          </div>
        </template>
        <!-- //---Form---// -->
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Id Facturador</label>
                <input type="text" v-model="id_invoicer" class="form-control inputCreate" placeholder="0004">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">DV</label>
                <input type="number" v-model="dv" class="form-control inputCreate" placeholder="8">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Tipo Documento</label>
                <Select v-model="doc_code" :options="arrTechnical" optionValue="codigo" filter optionLabel="significado"
                  class="form-select form-select-sm" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Documento</label>
                <input type="number" v-model="document" class="form-control inputCreate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Codigo Contribuyente</label>
                <input type="number" v-model="taxpayer_code" class="form-control inputCreate" placeholder="1">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Codigo Actividad</label>
                <input type="number" v-model="activity_code" class="form-control inputCreate" placeholder="5619">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Razón Social</label>
                <input type="text" v-model="register_name" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Nombre Comercial</label>
                <input type="text" v-model="trade_name" class="form-control inputCreate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Correo</label>
                <input type="email" v-model="email" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Telefono</label>
                <input type="number" v-model="phone" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Dirección</label>
                <input type="text" v-model="address" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Nombre Representate</label>
                <input type="text" v-model="agent_name" class="form-control inputCreate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Email Representante</label>
                <input type="email" v-model="agent_email" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Telefono Representante</label>
                <input type="number" v-model="agent_phone" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <label for="exampleFormControlInput1" class="form-label">Pais</label>
              <Select v-model="selectedCountry" @change="selectContryCode" :options="contry" filter
                optionLabel="nombre_comun" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="code_contry" class="form-label">Codigo Pais</label>
                <input type="number" :value="selectedCodeCountry" class="form-control inputCreate" disabled
                  id="code_contry">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="selectedDeparment" class="form-label">Departamento</label>
              <Select v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" filter
                optionLabel="departamento" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="ciudad_municipio" class="form-label">Codigo Departamento</label>
                <input type="number" :value=selectedCodeDeparment class="form-control inputCreate" disabled
                  id="ciudad_municipio">
              </div>
            </div>
            <div class="col-md-3">
              <label for="selectedMunicipaly" class="form-label">Municipio</label>
              <Select v-model="selectedMunicipaly" @change="selectedCodeMun" :options="municipalities" filter
                optionLabel="municipio" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="rangeTo_number" class="form-label">Codigo Municipio</label>
                <input type="number" :value="selectedCodeMunicipaly" class="form-control inputCreate" disabled
                  id="rangeTo_number">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Codigo Postal</label>
                <input type="text" v-model="zip_code" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Software ID</label>
                <input type="text" v-model="software_id" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Pin</label>
                <input type="number" v-model="pin" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Autorizacion Proveedor</label>
              <input type="number" v-model="supplier_authorization" class="form-control inputCreate">
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="code_contry" class="form-label">Tipo De Operacion</label>
                <input type="number" v-model="operation_type" class="form-control inputCreate" placeholder="10">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="address" class="form-label">Perfil De Operacion</label>
                <input type="text" v-model="profile_operation" class="form-control inputCreate" placeholder="1">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Nivel De Impuesto</label>
                <input type="text" v-model="level_duties" class="form-control inputCreate" placeholder="O-23">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Esquema Impuesto</label>
                <input type="text" v-model="scheme_duties" class="form-control inputCreate" placeholder="01">
              </div>
            </div>
          </div>
        </div>
        <!-- //---Form---// -->
        <template #footer>
          <Button label="Cancel" text severity="danger" @click="modalCreated = false" autofocus />
          <Button label="Guardar" outlined severity="primary" @click="save" autofocus />
        </template>
      </Dialog>

      <!-- //---Modal Update---// -->
      <Dialog v-model:visible="modalUpdate" position="top" modal :header="title" :style="{ width: '100%' }">
        <template #header>
          <div class="inline-flex items-center justify-center gap-2">
            <span class="font-bold whitespace-nowrap">Actualizar Facturador</span>
          </div>
        </template>
        <!-- //---Form---// -->
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Id Facturador</label>
                <input type="text" v-model="id_invoicer" class="form-control inputCreate" placeholder="0004">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">DV</label>
                <input type="number" v-model="dv" class="form-control inputCreate" placeholder="8">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Tipo Documento</label>
                <Select v-model="doc_code" :options="arrTechnical" optionValue="codigo" filter optionLabel="significado"
                  class="form-select form-select-sm" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Documento</label>
                <input type="number" v-model="document" class="form-control inputCreate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Codigo Contribuyente</label>
                <input type="number" v-model="taxpayer_code" class="form-control inputCreate" placeholder="1">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Codigo Actividad</label>
                <input type="number" v-model="activity_code" class="form-control inputCreate" placeholder="5619">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Razón Social</label>
                <input type="text" v-model="register_name" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Nombre Comercial</label>
                <input type="text" v-model="trade_name" class="form-control inputCreate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Correo</label>
                <input type="email" v-model="email" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Telefono</label>
                <input type="number" v-model="phone" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Dirección</label>
                <input type="text" v-model="address" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Nombre Representate</label>
                <input type="text" v-model="agent_name" class="form-control inputCreate">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Email Representante</label>
                <input type="email" v-model="agent_email" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Telefono Representante</label>
                <input type="number" v-model="agent_phone" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <label for="nombre_comun" class="form-label">Pais</label>
              <Select  v-model="selectedCountry" @change="selectContryCode" optionValue="codigo_numerico" :options="contry" filter optionLabel="nombre_comun" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="code_contry" class="form-label">Codigo Pais</label>
                <input type="number" :value="selectedCodeCountry" class="form-control inputCreate"  disabled id="code_contry">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="selectedDeparment" class="form-label">Departamento</label>
              <Select  v-model="selectedDeparment" @change="municipalityAndCode" :options="departments" optionValue="codigo" filter optionLabel="departamento" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="ciudad_municipio" class="form-label">Codigo Departamento</label>
                <input type="number" :value=selectedCodeDeparment class="form-control inputCreate" disabled  id="ciudad_municipio">
              </div>
            </div>
            <div class="col-md-3">
              <label for="selectedMunicipaly" class="form-label">Municipio</label>
              <Select v-model="selectedMunicipaly" @change="selectedCodeMun" :options="municipalities" filter optionValue="codigo"
                optionLabel="municipio" class="form-select form-select-sm" />
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="rangeTo_number" class="form-label">Codigo Municipio</label>
                <input type="number" :value="selectedCodeMunicipaly" class="form-control inputCreate" disabled
                  id="rangeTo_number">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Codigo Postal</label>
                <input type="text" v-model="zip_code" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Software ID</label>
                <input type="text" v-model="software_id" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label class="form-label">Pin</label>
                <input type="number" v-model="pin" class="form-control inputCreate">
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Autorizacion Proveedor</label>
              <input type="number" v-model="supplier_authorization" class="form-control inputCreate">
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="mb-3">
                <label for="code_contry" class="form-label">Tipo De Operacion</label>
                <input type="number" v-model="operation_type" class="form-control inputCreate" placeholder="10">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="address" class="form-label">Perfil De Operacion</label>
                <input type="text" v-model="profile_operation" class="form-control inputCreate" placeholder="1">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Nivel De Impuesto</label>
                <input type="text" v-model="level_duties" class="form-control inputCreate" placeholder="O-23">
              </div>
            </div>
            <div class="col-md-3">
              <div class="mb-3">
                <label for="zip_code" class="form-label">Esquema Impuesto</label>
                <input type="text" v-model="scheme_duties" class="form-control inputCreate" placeholder="01">
              </div>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Cancel" text severity="danger" @click="modalUpdate = false" autofocus />
          <Button label="Actualizar" outlined severity="primary" @click="update" autofocus />
        </template>
      </Dialog>
    </div>
  </div>
</template>

<style scoped>
.inputCreate {
  height: 3rem !important;
}
</style>
